const DOCUMENT_COLOR_IN_EDITOR_KEY = "bedrock-document-color-in-editor";

export function loadDocumentColorInEditor(): boolean {
  try { return localStorage.getItem(DOCUMENT_COLOR_IN_EDITOR_KEY) !== "off"; }
  catch { return true; }
}
export function saveDocumentColorInEditor(enabled: boolean): void {
  try { localStorage.setItem(DOCUMENT_COLOR_IN_EDITOR_KEY, enabled ? "on" : "off"); } catch { /* preferences remain usable in memory */ }
}
